module.exports = __webpack_public_path__ + "img/process-icon-5.44aea140.svg";